"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ERC1967UpgradeUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _ERC1967UpgradeUpgradeable__factory.ERC1967UpgradeUpgradeable__factory;
  }
});

var _ERC1967UpgradeUpgradeable__factory = require("./ERC1967UpgradeUpgradeable__factory");